import React from "react";
import { Link } from "react-router-dom";

const comingSoon: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Coming Soon</h1>
      <p className="text-lg text-gray-600 mb-8">
        We're working on something awesome! Stay tuned!
      </p>
      <Link
        to={"/dashboard"}
        className="px-4 py-2 bg-customGreenColor text-white rounded hover:bg-customGreenColor transition"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default comingSoon;
